import { Component, inject } from '@angular/core';
import { App } from '@app/core/models/app.model';
import { ResetCurrentApp } from '@app/core/states/app.actions';
import { AppState } from '@app/core/states/app.state';
import { AppConfig } from '@app/features/app-content/models/app-config.model';
import {
  AppConfigurationState,
  planNames,
} from '@app/features/app-content/states/app-configuration.state';
import { constructAssetUrl } from '@app/features/app-settings/states/assets.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-admin-warning',
  templateUrl: './admin-warning.component.html',
  styleUrls: ['./admin-warning.component.scss'],
  standalone: false,
})
export class AdminWarningComponent {
  private readonly store = inject(Store);
  // observables may have different availability depending on current page context
  currentApp$: Observable<App> = this.store.select(AppState.currentApp);
  currentAppConfig$: Observable<AppConfig> = this.store.select(
    AppConfigurationState.currentAppConfig,
  );

  planName(app: any): string | null {
    if (!app) {
      return null;
    }

    const planId = app.newidplan || app.planId || app.idplan;
    if (!planId) {
      return null;
    }

    return planNames.find(p => p.id === planId)?.name ?? null;
  }

  resetCurrentApp() {
    this.store.dispatch(new ResetCurrentApp());
  }

  private isUrl(str: string): boolean {
    if (!str) {
      return false;
    }

    return str.startsWith('http://') || str.startsWith('https://') || str.startsWith('//');
  }

  logoUrl(app: any): string {
    if (!app?.logo) {
      return '/assets/generic-app-icon.png';
    }

    // if logo is already a full url, use it directly
    if (this.isUrl(app.logo)) {
      return app.logo;
    }

    // otherwise, construct the full url from the partial path
    return constructAssetUrl(app.logo) || '/assets/generic-app-icon.png';
  }
}
